import { render, staticRenderFns } from "./goodPerson.vue?vue&type=template&id=0d49924a&scoped=true&"
import script from "./goodPerson.vue?vue&type=script&lang=js&"
export * from "./goodPerson.vue?vue&type=script&lang=js&"
import style0 from "./goodPerson.vue?vue&type=style&index=0&id=0d49924a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49924a",
  null
  
)

export default component.exports